export type KeyValuePair<TKey, TValue> = [TKey, TValue];

export const KeyValuePair = <TKey, TValue>(key: TKey, value: TValue): KeyValuePair<TKey, TValue> => [key, value];
